import { UserCredentialsType } from '@/components/modules/Users/types/UserCredentials';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const AddAdminForm = () => {
  return (
    <FormGridContainer fieldVariant={FieldVariant.form} fullWidth>
      <TextFormField label={`${UserCredentialsType.ADMIN}_EMAIL`} name={'username'} />
      <TextFormField label={'PASSWORD'} name={'password'} />
    </FormGridContainer>
  );
};
